export default "__VITE_ASSET__56dcc26d__"